module.exports = __webpack_public_path__ + "img/Share_hover_pt.e06b6c41.svg";